export default __webpack_public_path__ + "resources/icons/n242-80d2.webp";